var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"use-landscape-message"}},[_c('div',{staticClass:"info"},[_c('h3',{staticClass:"text-center"},[_vm._v("Please use landscape mode")]),_c('img',{staticClass:"mt-5",attrs:{"src":"/img/icons/icon-rotate-mobile.png","alt":""}})])])
}]

export { render, staticRenderFns }